import { useInfiniteQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchJvEmployees, fetchMemberByEmployeeId, fetchReadJvClient } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';
import { camelCaseToWords } from "../../utils/commonUtils";
import { AsyncPaginate } from "react-select-async-paginate";
import { customStyles } from "../../utils/styleUtils";
import { loadClients } from "../../utils/optionLoaderUtils";
import { clientOptionFromSearchParams } from "./clientQuery";
const searcHMemberOptions = [
    'clientId',
    'ssn',
    'certificateNumber',
    'lastName',
].map(str => ({ value: str, label: camelCaseToWords(str) }))

const Employees = () => {
    const [searchParams] = useSearchParams();
    const clientFromUrl = clientOptionFromSearchParams(searchParams);

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [selectedMemberSearchOption, setSelectedMemberSearchOption] = useState(() =>
        clientFromUrl ? searcHMemberOptions.find((opt) => opt.value === 'clientId') : undefined
    )
    const [selectedClient, setSelectedClient] = useState(() => clientFromUrl)
    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["employees", selectedMemberSearchOption, decouncedSearchValue, selectedClient],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue && selectedMemberSearchOption?.value) {
                params[selectedMemberSearchOption?.value] = decouncedSearchValue;

            }

            if (selectedMemberSearchOption?.value === 'clientId') {
                params[selectedMemberSearchOption?.value] = selectedClient?.value
                params['BlkOfBusID'] = selectedClient?.additional.blkofbusid
            }

            // if (decouncedSearchValue) {
            //     params.nextPageUrl = `eligibility/searchEmployees/certificateNumber/${decouncedSearchValue}`;
            // }
            //  console.log({ params })
            return await fetchJvEmployees(params);
        },

        select: (data) => {
            //   console.log({ data });
            return {
                //  count: data.pages?.[0]?.MetaData.RecordCount,
                rows: data.pages.map((page) => page.Response.MemberDetails).flatMap((x) => x).filter(x => Object.keys(x)?.length),

            };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            //    console.log({ lastPage })
            const nextPageUrl = lastPage?.Response?.Pagination?.Next

            if (!nextPageUrl) return undefined;
            return {
                nextPageUrl: nextPageUrl.split('/rest/')[1]
            }
        },
        staleTime: 0,
        retry: false,
        enabled: !!(selectedMemberSearchOption && (decouncedSearchValue || selectedClient)),
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event?.target?.value?.trim());
        }, 500),
        []
    );

    const columns = ['EmployeeID', 'DepSequenceNumber', 'EmployeeCertNum', 'EmployeeFirstName', 'EmployeeLastName', 'Relationship', 'SSN', 'Eligibility.Locations', 'Eligibility.EffectiveDate'];

    const onDetailHandler = async (body) => {
        const result = await fetchMemberByEmployeeId({ employeeid: body.EmployeeID, DepSequenceNumber: body.DepSequenceNumber })
        return result
    }


    return (
        <div className={'container '}>
            <p className='title'>Employees</p>
            <p className="sub-title">JV employees </p>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>


                    <Select
                        name={'memberSearch'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Search'}

                        isClearable={true}
                        // inputRef={field.ref}
                        options={searcHMemberOptions}
                        value={selectedMemberSearchOption} // Pass the state variable here
                        onChange={(option) => {
                            setSelectedMemberSearchOption(option);
                            setSelectedClient(null);
                            setSearchValue(null)
                            setDecouncedSearchValue("");
                            setSearchValue("");


                        }}
                    // value={options.find((c) => c.value === field.value)}
                    // onChange={(val) => field.onChange(val.value)}
                    />

                    {selectedMemberSearchOption?.value === 'clientId' ?
                        <AsyncPaginate

                            placeholder={`ClientId`}
                            className="react-select-container large-input"
                            classNamePrefix={"react-select"}
                            debounceTimeout={300}
                            value={selectedClient}
                            //  cacheUniqs={[i]}
                            clearCacheOnMenuClose={true}
                            clearCacheOnSearchChange={true}
                            isSearchable={true}
                            loadOptions={loadClients} //{i ? loadAccounts : loadAccountHccIdentificationNumber}
                            onChange={v => setSelectedClient(v)}

                            styles={customStyles}
                            isClearable={true}
                        /> : <input
                            style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                            type="text"
                            id={"search"}
                            placeholder="search..."
                            // list="items"
                            autoComplete="off"
                            // onFocus={() => setCurrentPage(0)}
                            onChange={(e) => {
                                setSearchValue(e.target.value?.trim()?.replaceAll('-', ''));
                                debouncedChangeHandler(e);
                            }}
                            value={searchValue}
                        />
                    }


                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {


                        setSelectedMemberSearchOption(null);
                        setSelectedClient(null);

                        setSearchValue("");
                        setDecouncedSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error:  {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"employes"}
                        columns={columns}
                        disableHeaderFormatting={true}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onEditHandler={onEditHandler}
                        //  onDetailHandler={onDetailHandler}
                        disableModel={true}
                        onDetailHandler={async (body) => body?.CertificateNumber && window.open(`/jv/employees/${body?.CertificateNumber}/${body?.DepSequenceNumber}`, '_blank', 'noopener,noreferrer')}

                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}
export default Employees